module.exports = __webpack_public_path__ + "img/patener_merge_1x.80a79c36.png";